module.exports = __webpack_public_path__ + "img/undraw_airport_2581.8962bfc5.svg";